import TileWMS from 'ol/source/TileWMS';
import {inAndOut} from 'ol/easing';
import { getCenter as getExtentCenter, isEmpty } from 'ol/extent';
import { tileWMSLayers,PROXY_PREFIX } from './layers/index';
import { defaults as defaultControls } from 'ol/control';
import MousePosition from 'ol/control/MousePosition';
import ZoomToExtent from 'ol/control/ZoomToExtent';
import ScaleLine from 'ol/control/ScaleLine';
import {createStringXY} from 'ol/coordinate';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Map from 'ol/Map';
import View from 'ol/View';
import { allLayersList as layers } from '../js/layers/index';
import Text from 'ol/style/Text';
import { bus } from '../main';


export const nepalBounds = [80.05, 26.3, 88.21, 30.6];

let map = null;

export const getMap = (check) => {
    console.assert(check || map, "Map not initialized!")
    return map;
};

const getControls = () =>
{
   const zoomIcon = document.createElement('span');
   zoomIcon.style.display = 'flex';
   zoomIcon.style.justifyContent = 'center';
   zoomIcon.style.alignItems = 'center';
   zoomIcon.innerHTML = '<img id="nepal-extent-tool" src="/nepal-extent-btn.svg">';

   return defaultControls({ attribution: false }).extend([
      new MousePosition({ coordinateFormat: createStringXY(4) }),
      new ZoomToExtent({ extent: nepalBounds, label: zoomIcon }),
      new ScaleLine({ unit: 'metric' }),
   ]);
};


export const initMap = ({target}) =>
{
    map = new Map({
        target: target,
        layers,
        controls: getControls(),
        view: new View({ center: [84, 27.5], zoom: 7, projection: 'EPSG:4326', duration: 250 }),
    });
    map.on('moveend', () =>
    {
        if (map.getView().getResolution() < 0.001)
        {
            bus.$emit('enable-municipality-checkbox');
        }
        else
        {
            bus.$emit('disable-municipality-checkbox');
        }
    });

    map.on('pointermove', function (event)
    {
        const hit = this.forEachFeatureAtPixel(event.pixel, () => true)
        this.getTargetElement().style.cursor = hit ? 'pointer' : '';
    });
    return map;
}

const getResolutionForExtent = (extent) =>
{
  const [width, height] = map.getSize(); // width height of map container in pxl
  const [minX, minY, maxX, maxY] = extent;
  return Math.max((maxX-minX)/width, (maxY-minY)/height) * 1.15;
};

export const fitToNepalBounds = () =>
{
    fitToExtent(nepalBounds);
}

export const animateToExtent = (newExtent, speedFactor=1) =>
{
  const newResolution = getResolutionForExtent(newExtent);
  map.getView().animate(
    // { resolution: map.getView().getResolution()*1.2, duration: 650/speedFactor, easing: inAndOut },
    { center: getExtentCenter(newExtent), duration: 650/speedFactor, easing: inAndOut },
    { resolution: newResolution, duration: 650/speedFactor, easing: inAndOut }
  );
};

export const animateResolution = (resolution, speedFactor) =>
{
    map.getView().animate(
        { resolution: resolution, duration: 650/speedFactor, easing: inAndOut },
    );
};

export const fitToExtent = (extent) =>
{
    if (isEmpty(extent))
    {
        console.error("Empty extent passed to fitToExtent");
        return;
    }
    const map = getMap();
    const resolution = map.getView().getResolution();
    animateResolution(resolution*1.04, 150);
    setTimeout(() =>
    {
        animateToExtent(extent, 2);
    }, 200);
    // map.getView().setCenter(getExtentCenter(extent));
    // map.getView().setResolution(getResolutionForExtent(extent));
}

export const getPolygonStyle = (fill, stroke, strokeWidth, font, fontColor) =>
{
    return new Style({
        fill: new Fill({ color: fill }),
        stroke: new Stroke({ color: stroke, width: strokeWidth }),
        text: new Text({
            font: font,
            fill: new Fill({color: fontColor}),
            stroke: new Stroke({color: 'rgba(255,255,255,1)', width: 2}),
        }),
    });
};

export const animateToPoint = (lnglat) =>
{
    if (lnglat.some(isNaN) || lnglat.length !== 2) {
        return;
    }
    map.getView().animate(
        { center: lnglat, easing: inAndOut },
        { zoom: 10, duration: 2000, easing: inAndOut }
    );
};

        
export function proxifyWMSLayers()
{
    tileWMSLayers.forEach(layer =>
    {
        const oldSource = layer.getSource();
        const oldUrl = oldSource.getUrls()[0];
        const newUrl = oldUrl.includes(PROXY_PREFIX) || PROXY_PREFIX + oldUrl;
        layer.setSource( new TileWMS({
            url: newUrl,
            params: { ...oldSource.getParams() },
            crossOrigin: 'anonymous'
        }) );
    });
}

export function deproxifyWMSLayers()
{
    tileWMSLayers.forEach(layer =>
    {
        const oldSource = layer.getSource();
        const oldUrl = oldSource.getUrls()[0];
        const newUrl = oldUrl.replace(PROXY_PREFIX,"");
        layer.setSource( new TileWMS({
            url: newUrl,
            params: { ...oldSource.getParams() },
        }) );
    });
}
